"use client";

import React from "react";
import { Activity, ShieldCheck, Zap, TestTube } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const scienceFeatures = [{
  title: "Titration Support",
  description: "We provide expert-guided titration protocols to ensure every patient reaches therapeutic levels comfortably and effectively.",
  icon: Activity
}, {
  title: "Patient Education",
  description: "Comprehensive resources and in-office training help patients understand their diagnosis and the long-term benefits of oral appliances.",
  icon: ShieldCheck
}, {
  title: "Detailed Reporting",
  description: "Receive regular clinical updates and objective progress reports sent directly to your office for seamless co-management of patient care.",
  icon: TestTube
}, {
  title: "Insurance Advocacy",
  description: "Our dedicated team handles pre-authorizations and medical insurance billing to maximize patient benefits and streamline the process.",
  icon: Zap
}];
export default function TheScienceOfAlluvi() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="181461" id="referral-benefits" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="h-[800px] w-[800px] rounded-full bg-[radial-gradient(circle_at_center,var(--color-secondary)_0%,transparent_60%)] opacity-5 blur-3xl" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        {}
        <div ref={headerReveal.ref} className={`mx-auto max-w-3xl text-center transition-all duration-1000 ease-out ${headerReveal.isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="mb-4 text-3xl font-bold tracking-tight text-primary sm:text-4xl md:text-5xl lg:text-6xl">
            Partnering for <span className="font-light text-secondary">Patient Success</span>
          </h2>
          <p className="text-muted-foreground md:text-lg/relaxed lg:text-xl/relaxed mb-16">
            We work alongside referring physicians to provide specialized oral appliance
            therapy, ensuring a collaborative approach to treating obstructive sleep apnea.
          </p>
        </div>

        {}
        <div ref={gridReveal.ref} className={`mx-auto grid max-w-5xl grid-cols-1 gap-6 md:grid-cols-2 lg:gap-8 transition-all duration-1000 delay-200 ease-out ${gridReveal.isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {scienceFeatures.map((feature, i) => <Card key={i} data-index={i} className="group relative overflow-hidden !bg-white border-border shadow-sm transition-all hover:shadow-lg hover:border-secondary/30">
              {}
              <div className="absolute inset-0 bg-gradient-to-br from-secondary/5 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
              
              <CardHeader className="relative z-10 pb-2">
                <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary ring-1 ring-primary/20 transition-colors group-hover:bg-secondary/10 group-hover:text-secondary group-hover:ring-secondary/30">
                  <feature.icon className="h-6 w-6" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-xl font-bold tracking-tight text-primary">
                  {feature.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="relative z-10">
                <CardDescription className="text-base leading-relaxed text-muted-foreground">
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}